<ui-card>
    <h2 id="approval-flow">{{ 'change-requests.approvalFlow' | translate }}</h2>
    <div>
        <ui-approval-flow [approvalFlowSteps]="approvalFlowSteps" aria-labelledby="approval-flow"></ui-approval-flow>

        <p *ngIf="isCurrentApprover && !isCancelled && !stepEmployeeActioned" class="approval-flow-info">
            {{ 'change-requests.itsYourTurnToApproveOrDenyThisRequest' | translate }}
        </p>

        <p *ngIf="isApproved">{{ 'change-requests.requestApprovedInstruction' | translate }}</p>

        <div *ngIf="canBeActioned && !hasBeenForcedActioned">
            <div *ngIf="isCurrentApprover && isAdmin && !stepEmployeeActioned" class="margin-top-1 flex justify-end">
                <div class="buttons">
                    <ui-button type="outline" (click)="approvalActioned.emit(approvalActions.Deny)">{{
                        'deny' | translate
                    }}</ui-button>
                    <ng-container>
                        <ui-button type="primary" [matMenu]="approveStepMenu"
                            >{{ 'approve' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
                        </ui-button>
                        <mat-menu #approveStepMenu="matMenu">
                            <button mat-menu-item (click)="approvalActioned.emit(approvalActions.Approve)">
                                {{ 'approve' | translate }} this step
                            </button>
                            <button mat-menu-item (click)="approvalActioned.emit(approvalActions.ForceApprove)">
                                {{ 'change-requests.forceApprove' | translate }} (all remaining steps)
                            </button>
                        </mat-menu>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="(!isCurrentApprover || stepEmployeeActioned) && isAdmin" class="margin-top-1 flex justify-end">
                <ui-button type="outline" (click)="approvalActioned.emit(approvalActions.ForceDeny)">{{
                    'change-requests.forceDeny' | translate
                }}</ui-button>
                <ui-button type="outline" (click)="approvalActioned.emit(approvalActions.ForceApprove)">{{
                    'change-requests.forceApprove' | translate
                }}</ui-button>
            </div>

            <div *ngIf="isCurrentApprover && !isAdmin && !stepEmployeeActioned" class="margin-top-1 flex justify-end">
                <ui-button type="outline" (click)="approvalActioned.emit(approvalActions.Deny)">{{
                    'deny' | translate
                }}</ui-button>
                <ui-button type="primary" (click)="approvalActioned.emit(approvalActions.Approve)">{{
                    'approve' | translate
                }}</ui-button>
            </div>
        </div>
    </div>
</ui-card>
